export default "__VITE_ASSET__BXcziIVE__"